export const suggestions = [
  { text: "What is MOM percentage?" },
  { text: "What is folio no?" },
  { text: "From where Rejected transaction reason data come in the software?" },
  { text: "What is new SIP report?" },
  { text: "Explain Business opportunity report" },
  { text: "Whats meaning by running SIP?" },
  { text: "What is a due diligence report?" },
  { text: "Explain Monthly MIS" },
  { text: "Can I track the status of my SMS credits?" },
  { text: "Can I see a list of all clients with SIP due?" },
  { text: "What is trend report?" },
  {text:  "How much back data shown in SIp business chart"},
  { text: "What is red error showing on dashboard" },
  { text: "What mean by live fund in P&L report?" },
  { text: "Can we change colours of web version?" },
  { text: "How much back data shown in SIp business chart?" },
  { text: "How much time taken for uploading SIP and Folio file?" },
  { text: "What is split in equity?" },
  { text: "What we do if file not receive on our end?" },
  { text: "Explain Advisor Setting" },
  { text: "What is Pay Premium?"},
  { text: "How do I set up alerts for important events?" },
  { text: "What does the Enable/Disable module do?" },
  { text: "Explain Idea Bank Benefits for MFDs" },
  { text: "What is the purpose of financial planning?" },
  { text: "What is bonus in equity" },
  { text: "What is the CRM Module?" },
  { text: "How do I add a new category in CRM settings?" },
  { text: "How do I generate a client report?" },
  { text: "How do I assign categories to clients or families?" },
  { text: "How do I assign bouquets to clients?" },
  { text: "How can I upload and store files in the EVault?" },
  { text: "What is the rule calling CAS?" },
  { text: "What is Held-away portfolio?" },
  { text: "How do I delete an item in the Bouquet Manager?" },
  { text: "How do I edit a vendor’s details?" }
];